import React, { Component } from 'react'
import { Select } from '@driftt/tide-core-legacy'
import { api } from 'app/modules/sfdc/api'
import './style.styl'

const DEFAULT_LABEL = "Don't set field"
const DESCRIPTION = `When Drift sends a meeting to Salesforce, we’ll populate the field you select below with the name or email of the user that shared the calendar. These are pulled from your configured event fields in Salesforce.`

const DEFAULT_OPTION = { value: null, label: DEFAULT_LABEL }

const eventToSelectOption = (field) => ({
    value: field.name,
    label: field.label
})

class SalesforceMeetingBookedBySelect extends Component {

    constructor(props) {
        super(props)

        this.state = {
            options: [],
            allFields: [],
            selectValue: null,
            selectLabel: null
        }
    }

    componentDidMount() {
        this.fetchData()
    }

    fetchData = async () => {
        const allFields = await api.getSalesforceMeetingEventFields()
        const field = await api.getSalesforceBookedByField().catch(e => {
            return null
        })

        if (!!field) {
            const wasFieldDeletedInSalesforce = allFields.filter(aField => aField.label === field.label)[0]
            if (!!wasFieldDeletedInSalesforce) {
                this.setState({
                    options: allFields.map(eventToSelectOption),
                    selectLabel: field.label,
                    selectValue: field.name,
                    allFields: allFields
                })
            } else {
                console.log(`The field "${field.label}" was previously saved but appears to have been deleted from salesforce. We have deleted the mapping.`)
                api.deleteSalesforceBookedByField()
            }
        }
        else {
            this.setState({
                options: allFields.map(eventToSelectOption),
                selectLabel: null,
                selectValue: null,
                allFields: allFields
            })
        }
    }

    onChange = async ({ label, value }) => {
        if (!!!value) {
            await api.deleteSalesforceBookedByField()
        }
        else {
            const { allFields } = this.state
            const field = allFields.filter(field => field.label === label)[0]
            api.setSalesforceBookedByField(field)
        }
        this.setState({
            selectValue: value,
            selectLabel: label,
        })
    }

    render() {
        const { options, selectValue } = this.state
        return (
            <div  className="booked-by-event-field-holder">
                <strong>Set calendar shared by user field</strong>
                <p className="booked-by-event-description">{DESCRIPTION}</p>
                <Select className="salesforce-activity-select-input"
                    placeholder={DEFAULT_LABEL}
                    options={options}
                    onChange={this.onChange}
                    value={selectValue}
                    resetValue={DEFAULT_OPTION}
                />
            </div>
        )
    }
}


export default SalesforceMeetingBookedBySelect


// WEBPACK FOOTER //
// ./src/scripts/components/Integration/pages/SalesforceConfig/SalesforceMeetingBookedBySelect.js